import { useRender } from "@base-ui/react/use-render";
import type { ComponentProps, ReactElement } from "react";

import { useLinkRender } from "./linkContext.js";

export interface AppLinkProps extends ComponentProps<"a"> {
  /** The app's router link for this one link, over the LinkProvider's. */
  render?: ReactElement;
}

/** An in-app link: through `render`, else the LinkProvider's router link, else a plain `<a>`. */
export function AppLink({ render, ...props }: AppLinkProps) {
  return useRender({ render: useLinkRender(render), defaultTagName: "a", props });
}
